import { render } from "./BoxPage.vue?vue&type=template&id=2cac17c3"
import script from "./BoxPage.vue?vue&type=script&lang=js"
export * from "./BoxPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__